export default {
  baseStyle: {
    height: '1em',
  },
};
